export const durationFastRace = new Array(14).fill(null);
